import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  id: "language-selector",
  class: "dropdown dropdown-left"
}
const _hoisted_2 = ["data-tip"]
const _hoisted_3 = {
  tabindex: "0",
  class: "dropdown-content menu p-2 shadow bg-base-100 rounded-box w-52"
}
const _hoisted_4 = ["value"]
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mdicon = _resolveComponent("mdicon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "tooltip tooltip-bottom",
      "data-tip": _ctx.$t('language-selector')
    }, [
      _createElementVNode("label", {
        tabindex: "0",
        class: _normalizeClass(_ctx.type === 'button' ? 'btn btn-circle' : '')
      }, [
        _createVNode(_component_mdicon, {
          class: "hover:text-warning cursor-pointer duration-200",
          name: "translate",
          size: "20"
        })
      ], 2)
    ], 8, _hoisted_2),
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.langs, (lang, i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: `Lang${i}`,
          value: lang,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeAfterSelectAnOption && _ctx.closeAfterSelectAnOption(...args)))
        }, [
          _createElementVNode("a", {
            onClick: ($event: any) => (_ctx.updateLanguage(lang)),
            class: _normalizeClass(["text-gray-600 dark:text-gray-100 text-xs", lang === _ctx.$i18n.locale ? 'text-sky-500 dark:text-sky-300' : 'text-'])
          }, _toDisplayString(lang === 'en' ? 'English' : 'Español') + " - [" + _toDisplayString(lang) + "] ", 11, _hoisted_5)
        ], 8, _hoisted_4))
      }), 128))
    ])
  ]))
}